var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { id: "booking-verify" } },
    [
      _c("warehousing-tree-grid", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "list",
            expression: "view==='list'"
          }
        ],
        ref: "warehousingTreeGrid",
        attrs: { context: _vm.context, lob: _vm.lob },
        on: {
          look: _vm.lookHandle,
          edit: _vm.editHandle,
          add: _vm.addHandle,
          print: _vm.onListPrintHandler,
          refresh: _vm.refreshHandle
        }
      }),
      _c("warehousing-workspace", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail",
            expression: "view==='detail'"
          }
        ],
        ref: "warehousingWorkspace",
        attrs: { "parent-context": _vm.context, lob: _vm.lob },
        on: {
          add: _vm.addHandle,
          edit: _vm.editHandle,
          look: _vm.lookHandle,
          back: _vm.backToList,
          print: _vm.onPrintHandler,
          refresh: _vm.refreshHandle
        }
      }),
      _c("print-data-dialog", {
        ref: "printDataDialog",
        attrs: {
          "v-if": _vm.printDataDialog.visible,
          visible: _vm.printDataDialog.visible,
          row: _vm.printDataDialog.row,
          "print-params": _vm.printDataDialog.printParams,
          "need-r": _vm.printDataDialog.needR
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.printDataDialog, "visible", $event)
          },
          close: function($event) {
            _vm.printDataDialog.visible = false
          },
          printDataHandler: _vm.printDataHandler,
          refresh: _vm.refreshHandle
        }
      }),
      _c("cargo-template-selector-dialog", {
        ref: "templateSelectorDialog",
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }